// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Header from '../Header.jsx';
import PharmacySidebarMenu from './PharmacySidebarMenu.jsx';
import PharmacySidebarInfo from './PharmacySidebarInfo.jsx';
import StockReport from './StockReportPage.jsx';
import ExpirationReport from './ExpirationReportPage.jsx';
import Archived from './ArchivedPage.jsx';
import PharmacyInventory from './PharmacyInventoryPage.jsx';
import DispensaryHistory from './DispensaryHistoryPage.jsx';
import TransactionHistory from './TransactionHistoryPage.jsx';

import { fetchDrugListInitial } from '../../actions/pharmacyActions';

import styles from '../../styles/PharmacyTemplate.scss';

type Props = {
  pharmacy: Object,
  fetchDrugListInitial: Function,
  match: Object,
}

class PharmacyTemplateComponent extends Component<Props> {
  componentDidMount() {
    this.props.fetchDrugListInitial();
    document.title = 'Pharmacy - HFA EHR';
  }

  render() {
    const { match } = this.props;
    return (
      <div className={styles.pharmacyTemplate}>
        <Header />
        {this.props.pharmacy.status === 'SUCCESS'
          && <div className={styles.pageContainer}>
            <div className={styles.sidebar}>
              <PharmacySidebarInfo />
              <PharmacySidebarMenu match={match} />
            </div>
            <div className={styles.content}>
              <Switch>
                <Route path={match.url} component={PharmacyInventory} exact={true} />
                <Route path={`${match.url}/inventory`} component={PharmacyInventory} />
                <Route path={`${match.url}/stock`} component={StockReport} />
                <Route path={`${match.url}/expiration`} component={ExpirationReport} />
                <Route path={`${match.url}/archived`} component={Archived} />
                <Route path={`${match.url}/dispensaryReport`} component={DispensaryHistory} />
                <Route path={`${match.url}/transactionReport`} component={TransactionHistory} />
              </Switch>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pharmacy: state.pharmacy,
});

const mapDispatchToProps = dispatch => ({
  fetchDrugListInitial: () => dispatch(fetchDrugListInitial()),
});

const PharmacyTemplate = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PharmacyTemplateComponent);

export default PharmacyTemplate;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/PharmacyTemplate.jsx